import React, { useState }  from "react";
import "../css/Paper.css";
import { ChevronUp, ChevronDown } from 'lucide-react';


const Paper = (props) => {

    const [isVisible, setIsVisible] = useState(false);

    const handleClick = () => {
      setIsVisible(!isVisible);
    };

  return (
    <div className={`paper-container ${props.animate ? 'paper-appear' : ''}`} style={props.animate ? { animationDelay: `${(props.appearIndex || 0) * 120}ms` } : undefined}>
        <h2>
            <a href={props.link} target="_blank" rel="noreferrer" className="paper-title-link">
                {props.title}
            </a>
        </h2>
        {props.authors?<p>Co-authored with {props.authors}</p>:<p>Single-authored</p>}
        {props.journal?<p>Published in <i>{props.journal}</i></p>:<p></p>}
        <div className="abstract">
            <h3 onClick={handleClick}>Abstract {isVisible && (<ChevronUp size={20} />)}{!isVisible && (<ChevronDown size={20} />)}</h3>
        </div>
        {isVisible && (<p className="abstract-text">{props.abstract}</p>)}
    </div>
  );
};

export default Paper;